import { render, staticRenderFns } from "./ApprovalResponse.vue?vue&type=template&id=623e2228&scoped=true&"
import script from "./ApprovalResponse.vue?vue&type=script&lang=js&"
export * from "./ApprovalResponse.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalResponse.vue?vue&type=style&index=0&id=623e2228&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623e2228",
  null
  
)

export default component.exports